<template>
    <ComboboxRoot v-bind="forwarded">
        <slot />
    </ComboboxRoot>
</template>

<script setup lang="ts">
/** Originally imported via shadcn-vue. See https://ui.shadcn.com/docs/components/combobox for further documentation.*/
import type { ComboboxRootEmits, ComboboxRootProps } from 'reka-ui';
import { ComboboxRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps<ComboboxRootProps>();
const emits = defineEmits<ComboboxRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>
